import {
  GET_DROPSHIP_SUMMARY_REPORTS_REQUEST,
  GET_DROPSHIP_SUMMARY_REPORTS_SUCCESS,
  GET_DROPSHIP_SUMMARY_REPORTS_ERROR,
  GET_DROPSHIP_SKU_REPORTS_REQUEST,
  GET_DROPSHIP_SKU_REPORTS_SUCCESS,
  GET_DROPSHIP_SKU_REPORTS_ERROR,
  GET_DROPSHIP_TOTAL_REPORTS_REQUEST,
  GET_DROPSHIP_TOTAL_REPORTS_SUCCESS,
  GET_DROPSHIP_TOTAL_REPORTS_ERROR,
  GET_DROPSHIP_LOCATION_REPORTS_REQUEST,
  GET_DROPSHIP_LOCATION_REPORTS_SUCCESS,
  GET_DROPSHIP_LOCATION_REPORTS_ERROR,
  GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_REQUEST,
  GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_SUCCESS,
  GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_ERROR,
  GET_DROPSHIP_DATA_REPORTS_REQUEST,
  GET_DROPSHIP_DATA_REPORTS_SUCCESS,
  GET_DROPSHIP_DATA_REPORTS_ERROR
} from "./types";
import axios from "axios";
import { BASEURL } from "../../constant/config.js";
import moment from "moment";

export const getDropshipSummary = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_SUMMARY_REPORTS_REQUEST });
  const newData = {
    cy_start_date: moment(values.from_date).format("MM-DD-YYYY"),
    cy_end_date: moment(values.to_date).format("MM-DD-YYYY"),
    ly_start_date: moment(values.from_date).subtract(1, 'year').format("MM-DD-YYYY"),
    ly_end_date: moment(values.to_date).subtract(1, 'year').format("MM-DD-YYYY"),
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropShipCustomerSummary`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_SUMMARY_REPORTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_SUMMARY_REPORTS_ERROR,
        payload: [],
      });
    });
};

export const getDropshipSKU =
  (token, values, stepschecked, report) => (dispatch) => {
    console.log({ stepschecked });
    dispatch({ type: GET_DROPSHIP_SKU_REPORTS_REQUEST });
    const newData = {
      from_date: moment(values.from_date).format("MM-DD-YYYY"),
      to_date: moment(values.to_date).format("MM-DD-YYYY"),
      customer_id: report.length > 0 ? report.toString() : null,
      gender_id:
        values.gender_id === "All" || values.gender_id === undefined
          ? null
          : values.gender_id,
      location_id: stepschecked.length === 0 ? null : stepschecked.toString(),
    };
    return axios({
      method: "POST",
      url: `${BASEURL}getAll/DropShipBySku`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + token,
      },
      data: newData,
    })
      .then((response) => {
        return dispatch({
          type: GET_DROPSHIP_SKU_REPORTS_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_DROPSHIP_SKU_REPORTS_ERROR,
          payload: [],
        });
      });
  };

export const getDropshipTotal = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_TOTAL_REPORTS_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    gender_id:
      values.gender_id === "All" || values.gender_id === undefined
        ? null
        : values.gender_id,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropShipTotal`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_TOTAL_REPORTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_TOTAL_REPORTS_ERROR,
        payload: [],
      });
    });
};

export const getDropshipLocation = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_LOCATION_REPORTS_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    gender_id: values.gender_id === "All" || values.gender_id === undefined ? null : values.gender_id,
    state_id: values.state === "All" || values.state === undefined ? null : values.state,
    city_id: values.city === "All" || values.city === undefined ? null : values.city,
    zip_code: values.zip === "All" || values.zip === undefined ? null : values.zip,
  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropShipByLocation`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_LOCATION_REPORTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_LOCATION_REPORTS_ERROR,
        payload: [],
      });
    });
};

export const getDropshipLocationByZip = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    customer_id: values.report && values.report.length > 0 ? values.report.toString() : null,
    gender_id: values.gender_id === "All" || values.gender_id === undefined ? null : values.gender_id,
    location_id: null,
    zip_code: values.zip === "All" || values.zip === undefined ? null : values.zip,

  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropShipLocationByZipCode`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_LOCATION_BY_ZIP_REPORTS_ERROR,
        payload: [],
      });
    });
};

export const getDropshipData = (token, values) => (dispatch) => {
  dispatch({ type: GET_DROPSHIP_DATA_REPORTS_REQUEST });
  const newData = {
    from_date: moment(values.from_date).format("MM-DD-YYYY"),
    to_date: moment(values.to_date).format("MM-DD-YYYY"),
    customer_id: values.report && values.report.length > 0 ? values.report.toString() : null,
    gender_id: values.gender_id === "All" || values.gender_id === undefined ? null : values.gender_id,
    location_id: null,
    zip_code: values.zip === "All" || values.zip === undefined ? null : values.zip,

  };
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/DropshipData`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: newData,
  })
    .then((response) => {
      return dispatch({
        type: GET_DROPSHIP_DATA_REPORTS_SUCCESS,
        payload: response.data,
      });
    })
    .catch((error) => {
      dispatch({
        type: GET_DROPSHIP_DATA_REPORTS_ERROR,
        payload: [],
      });
    });
};